import { Amplify } from 'aws-amplify';
import { getAwsConfig } from '../../config/appConfig';

let configured = false;

/**
 * Configure Amplify from the runtime config loaded at startup (`/config.json`).
 * Safe to call multiple times; only the first call takes effect.
 */
export function ensureAmplifyConfigured(): void {
    if (configured) {
        return;
    }

    const aws = getAwsConfig();

    // When employee SSO is configured, add the Hosted-UI OAuth block so
    // `signInWithRedirect` can launch the Midway login. The Hosted-UI domain is
    // supplied without its scheme, as Amplify expects. Redirects return to the
    // app's own origin.
    const oauth =
        aws.hostedUiDomain && aws.ssoClientId
            ? {
                  oauth: {
                      domain: aws.hostedUiDomain.replace(/^https?:\/\//, ''),
                      // Includes aws.cognito.signin.user.admin so Amplify can
                      // read user attributes after Hosted-UI login.
                      scopes: [
                          'openid',
                          'email',
                          'profile',
                          'aws.cognito.signin.user.admin',
                      ] as string[],
                      redirectSignIn: [`${window.location.origin}/`],
                      redirectSignOut: [`${window.location.origin}/`],
                      responseType: 'code' as const,
                  },
              }
            : {};

    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: aws.userPoolId,
                // A single web client handles both supplier SRP (password) and
                // employee OAuth (Midway Hosted UI), so one Amplify config
                // serves both flows.
                userPoolClientId: aws.userPoolClientId,
                identityPoolId: aws.identityPoolId,
                loginWith: { email: true, ...oauth },
            },
        },
        Storage: {
            S3: {
                bucket: aws.uploadsBucket,
                region: aws.region,
            },
        },
    });

    configured = true;
}

export default ensureAmplifyConfigured;
